<template>
  <div>
    <TabbedBox>
      <template v-slot:tablist>
        <Tab :first="true" tabid="tab-1">
          <i class="far fa-id-card-alt"></i> Contacts
        </Tab>
        <Tab tabid="tab-2">
          <i class="far fa-archive"></i> Archived
        </Tab>
      </template>
      <template v-slot:tabcontent>
        <TabPage :first="true" tabid="tab-1">
          <DataTable
            :columns="columnList"
            :url="dataURL"
            :filterOptions="contactFilterOptions"
            :displayTools="true"
            @rowClick="contactClicked"
            :displayExportTools="true"
            exportTitle="Contacts"
          >
            <template v-slot:title>
              <h3>Contacts List</h3>
            </template>
            <template v-slot:tools>
              <LinkButton type="new" href="/contacts/new" v-if="userHasCreatePermission(PermissionTypes.ContactPermissionTypes.contact)" sizeClass="btn"> New Contact</LinkButton>
            </template>
            <template v-slot:row="row">
              <tr :key="row.data.id">
                <td class="table-data-nav-link">
                  <LinkContact :name="row.data.name" :id="row.data.id" :newTab="false" />
                </td>
                <td>
                  <span v-if="row.data.isCustomer" class="label label-customer mr-1">
                    <i class="fas fa-user-circle"></i> customer
                  </span>
                  <span v-if="row.data.isSupplier" class="label label-supplier">
                    <i class="fas fa-industry"></i> supplier
                  </span>
                </td>
                <td>{{row.data.phone}}</td>
                <td>{{row.data.address}}</td>
                <td>{{row.data.creditDescription}}</td>
                <td>
                  <LabelTags :labelList="row.data.labelList" />
                </td>
              </tr>
            </template>
          </DataTable>
        </TabPage>

        <TabPage tabid="tab-2">
          <DataTable
            :columns="columnList"
            :url="archivedDataURL"
            :filterOptions="contactFilterOptions"
            @rowClick="contactClicked"
          >
            <template v-slot:title>
              <h3>Archived Contacts List</h3>
            </template>
            <template v-slot:row="row">
              <tr :key="row.data.id">
                <td class="table-data-nav-link">
                  <LinkContact :name="row.data.name" :id="row.data.id" :newTab="false" />
                </td>
                <td>
                  <span v-if="row.data.isCustomer" class="label label-customer">
                    <i class="fas fa-user-circle"></i> customer
                  </span>
                  <span v-if="row.data.isSupplier" class="label label-supplier">
                    <i class="fas fa-industry"></i> supplier
                  </span>
                </td>
                <td>{{row.data.phone}}</td>
                <td>{{row.data.address}}</td>
                <td>{{row.data.creditDescription}}</td>
                <td>
                  <LabelTags :labelList="row.data.labelList" />
                </td>
              </tr>
            </template>
          </DataTable>
        </TabPage>
      </template>
    </TabbedBox>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "ContactsList",
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title;
    },
    dataURL() {
      var params = {
      };

      return "contacts?" + $.param(params);
    },
    archivedDataURL() {
      var params = {
        isActive: 0
      };

      return "contacts?" + $.param(params);
    },
    contactFilterOptions() {
      var filterOptions = [
        {
          name: "Contact Type",
          options: [
            { name: "Customer", value: "isCustomer", class: "label-customer" },
            { name: "Supplier", value: "isSupplier", class: "label-supplier" }
          ]
        }
      ]

      let contactLabels = this.$store.getters['label/getLabelsByType']('contact')
      filterOptions.push({
        name: 'Contact Label',
        field: 'labelListNames',
        operator: 'like',
        options: contactLabels.reverse().map(labelInfo => {
            return {
              name: labelInfo.name,
              value: '%' + labelInfo.name + '%',
              colour: labelInfo.colour
            }
        })
      })

      return filterOptions
    }
  },
  data() {
    return {      
      columnList: [
        { title: "Name", data: "name" },
        { title: "Type", data: "type" },
        { title: "Phone", data: "phone" },
        { title: "Address", data: "address" },
        { title: "Credit", data: "creditDescription" },
        { title: "Labels", data: "labelList", type: 'label' }
      ]
    };
  },
  mounted() {
    this.requestFilterLabels()
  },
  methods: {
    getContactRouteForId(contactId) {
      return `/contacts/${contactId}`;
    },
    createContact() {
      this.$router.push("/contacts/new");
    },
    contactClicked(rowId) {
      this.$router.push(this.getContactRouteForId(rowId));
    },
    requestFilterLabels() {
      return new Promise(async (resolve, reject) => {
        try {
          // Get the label info for the filter popovers
          let contactLabels = await this.$apiService.coreService.getLabelsForType('contact')
          this.$store.commit({
            type: 'label/updateLabels',
            labelType: 'contact',
            labelList: contactLabels.data
          })

          return resolve()
        } catch(err) {
          return reject(err)
        }
      })      
    }
  }
};
</script>
